import { useState as d, useRef as h, useCallback as v, useEffect as a } from "react";
function A(l, i, f, o, u) {
  const [e, s] = d(0), [w, k] = d(0), [m, x] = d(f === void 0), r = h(null);
  function c(t) {
    s(t === "next" ? (n) => n + 1 : (n) => n - 1), x(!0);
  }
  const y = v(() => {
    var t;
    r.current && (k((t = r.current) == null ? void 0 : t.offsetWidth), r.current.style.transform = `translateX(${-(e * w)}px)`, m && (r.current.style.transition = "transform 0.3s ease-in-out"));
  }, [e, m, w]);
  return a(() => {
    s(f ?? 0);
  }, [i, f]), a(() => {
    setTimeout(() => {
      r.current && y();
    }, 0);
  }, [y, i, e]), a(() => {
    const t = (n) => {
      n.key === "ArrowRight" ? e !== l - 1 && c("next") : n.key === "ArrowLeft" && e !== 0 && c("prev");
    };
    return i && window.addEventListener("keydown", t), () => {
      window.removeEventListener("keydown", t);
    };
  }, [i, e, l]), {
    sliderRef: r,
    move: c,
    handleChange: (t) => {
      u == null || u(t), t || (o == null || o(t), s(0), x(!1));
    },
    currentIndex: e
  };
}
export {
  A as useImageCarousel
};
